import awsIcon from "@/assets/icons/integrations/aws.svg";
import awsLambdaIcon from "@/assets/icons/integrations/aws.lambda.svg";
import awsSqsIcon from "@/assets/icons/integrations/aws.sqs.svg";
import bitbucketIcon from "@/assets/icons/integrations/bitbucket.svg";
import awsEcsIcon from "@/assets/icons/integrations/aws.ecs.svg";
import circleciIcon from "@/assets/icons/integrations/circleci.svg";
import awsCloudwatchIcon from "@/assets/icons/integrations/aws.cloudwatch.svg";
import awsCodePipelineIcon from "@/assets/icons/integrations/aws.codepipeline.svg";
import awsSnsIcon from "@/assets/icons/integrations/aws.sns.svg";
import awsRoute53Icon from "@/assets/icons/integrations/aws.route53.svg";
import awsEc2Icon from "@/assets/icons/integrations/aws.ec2.svg";
import awsEcrIcon from "@/assets/icons/integrations/aws.ecr.svg";
import awsCodeArtifactIcon from "@/assets/icons/integrations/aws.codeartifact.svg";
import awsPrometheusIcon from "@/assets/icons/integrations/aws.prometheus.svg";
import azureIcon from "@/assets/icons/integrations/azure.svg";
import cloudflareIcon from "@/assets/icons/integrations/cloudflare.svg";
import cloudsmithIcon from "@/assets/icons/integrations/cloudsmith.svg";
import coolifyIcon from "@/assets/icons/integrations/coolify.svg";
import dash0Icon from "@/assets/icons/integrations/dash0.svg";
import datadogIcon from "@/assets/icons/integrations/datadog.svg";
import elasticIcon from "@/assets/icons/integrations/elastic.svg";
import daytonaIcon from "@/assets/icons/integrations/daytona.svg";
import digitaloceanIcon from "@/assets/icons/integrations/digitalocean.svg";
import discordIcon from "@/assets/icons/integrations/discord.svg";
import firehydrantIcon from "@/assets/icons/integrations/firehydrant.svg";
import telegramIcon from "@/assets/icons/integrations/telegram.svg";
import githubIcon from "@/assets/icons/integrations/github.svg";
import gitlabIcon from "@/assets/icons/integrations/gitlab.svg";
import grafanaIcon from "@/assets/icons/integrations/grafana.svg";
import jiraIcon from "@/assets/icons/integrations/jira.svg";
import linearIcon from "@/assets/icons/integrations/linear.svg";
import octopusIcon from "@/assets/icons/integrations/octopus.svg";
import openAiIcon from "@/assets/icons/integrations/openai.svg";
import openRouterIcon from "@/assets/icons/integrations/openrouter.svg";
import claudeIcon from "@/assets/icons/integrations/claude.svg";
import logfireIcon from "@/assets/icons/integrations/logfire.svg";
import gcpIcon from "@/assets/icons/integrations/gcp.svg";
import cloudBuildIcon from "@/assets/icons/integrations/cloud_build.svg";
import gcpCloudRunIcon from "@/assets/icons/integrations/gcp.cloudrun.svg";
import gcpArtifactRegistryIcon from "@/assets/icons/integrations/gcp.artifactregistry.svg";
import gcpPubSubIcon from "@/assets/icons/integrations/gcp.pubsub.svg";
import gcpCloudDNSIcon from "@/assets/icons/integrations/gcp.clouddns.svg";
import gcpComputeIcon from "@/assets/icons/integrations/gcp.compute.svg";
import gcpCloudSqlIcon from "@/assets/icons/integrations/gcp.cloudsql.svg";
import gcpStorageIcon from "@/assets/icons/integrations/gcp.storage.svg";
import gcpMonitoringIcon from "@/assets/icons/integrations/gcp.monitoring.svg";
import cursorIcon from "@/assets/icons/integrations/cursor.svg";
import perplexityIcon from "@/assets/icons/integrations/perplexity.svg";
import pagerDutyIcon from "@/assets/icons/integrations/pagerduty.svg";
import rootlyIcon from "@/assets/icons/integrations/rootly.svg";
import incidentIcon from "@/assets/icons/integrations/incident.svg";
import slackIcon from "@/assets/icons/integrations/slack.svg";
import smtpIcon from "@/assets/icons/integrations/smtp.svg";
import SemaphoreLogo from "@/assets/semaphore-logo-sign-black.svg";
import sendgridIcon from "@/assets/icons/integrations/sendgrid.svg";
import prometheusIcon from "@/assets/icons/integrations/prometheus.svg";
import renderIcon from "@/assets/icons/integrations/render.svg";
import sentryIcon from "@/assets/icons/integrations/sentry.svg";
import dockerIcon from "@/assets/icons/integrations/docker.svg";
import hetznerIcon from "@/assets/icons/integrations/hetzner.svg";
import honeycombIcon from "@/assets/icons/integrations/honeycomb.svg";
import jfrogArtifactoryIcon from "@/assets/icons/integrations/jfrog-artifactory.svg";
import harnessIcon from "@/assets/icons/integrations/harness.svg";
import newrelicIcon from "@/assets/icons/integrations/newrelic.svg";
import servicenowIcon from "@/assets/icons/integrations/servicenow.svg";
import statuspageIcon from "@/assets/icons/integrations/statuspage.svg";
import launchdarklyIcon from "@/assets/icons/integrations/launchdarkly.svg";
import teamsIcon from "@/assets/icons/integrations/teams.svg";
import ociIcon from "@/assets/icons/integrations/oci.svg";
import graphqlIcon from "@/assets/icons/graphql.svg";

/** Integration type name (e.g. "github") → logo src. Used for Settings tab and header. */
export const INTEGRATION_APP_LOGO_MAP: Record<string, string> = {
  aws: awsIcon,
  bitbucket: bitbucketIcon,
  circleci: circleciIcon,
  azure: azureIcon,
  cloudflare: cloudflareIcon,
  cloudsmith: cloudsmithIcon,
  coolify: coolifyIcon,
  dash0: dash0Icon,
  datadog: datadogIcon,
  daytona: daytonaIcon,
  digitalocean: digitaloceanIcon,
  discord: discordIcon,
  firehydrant: firehydrantIcon,
  telegram: telegramIcon,
  github: githubIcon,
  gitlab: gitlabIcon,
  hetzner: hetznerIcon,
  jfrogartifactory: jfrogArtifactoryIcon,
  grafana: grafanaIcon,
  jira: jiraIcon,
  linear: linearIcon,
  octopus: octopusIcon,
  openai: openAiIcon,
  "open-ai": openAiIcon,
  openrouter: openRouterIcon,
  claude: claudeIcon,
  logfire: logfireIcon,
  cursor: cursorIcon,
  perplexity: perplexityIcon,
  pagerduty: pagerDutyIcon,
  rootly: rootlyIcon,
  incident: incidentIcon,
  semaphore: SemaphoreLogo,
  slack: slackIcon,
  smtp: smtpIcon,
  sendgrid: sendgridIcon,
  sentry: sentryIcon,
  prometheus: prometheusIcon,
  render: renderIcon,
  dockerhub: dockerIcon,
  honeycomb: honeycombIcon,
  gcp: gcpIcon,
  harness: harnessIcon,
  newrelic: newrelicIcon,
  servicenow: servicenowIcon,
  statuspage: statuspageIcon,
  launchdarkly: launchdarklyIcon,
  teams: teamsIcon,
  elastic: elasticIcon,
  oci: ociIcon,
  graphql: graphqlIcon,
};

/** Block name first part (e.g. "github") or compound (e.g. aws.lambda) → logo src for header. */
export const APP_LOGO_MAP: Record<string, string | Record<string, string>> = {
  bitbucket: bitbucketIcon,
  circleci: circleciIcon,
  cloudflare: cloudflareIcon,
  cloudsmith: cloudsmithIcon,
  coolify: coolifyIcon,
  dash0: dash0Icon,
  datadog: datadogIcon,
  daytona: daytonaIcon,
  digitalocean: digitaloceanIcon,
  discord: discordIcon,
  firehydrant: firehydrantIcon,
  telegram: telegramIcon,
  github: githubIcon,
  gitlab: gitlabIcon,
  hetzner: hetznerIcon,
  jfrogArtifactory: jfrogArtifactoryIcon,
  grafana: grafanaIcon,
  jira: jiraIcon,
  linear: linearIcon,
  octopus: octopusIcon,
  openai: openAiIcon,
  "open-ai": openAiIcon,
  openrouter: openRouterIcon,
  claude: claudeIcon,
  logfire: logfireIcon,
  cursor: cursorIcon,
  perplexity: perplexityIcon,
  pagerduty: pagerDutyIcon,
  rootly: rootlyIcon,
  incident: incidentIcon,
  semaphore: SemaphoreLogo,
  slack: slackIcon,
  smtp: smtpIcon,
  sendgrid: sendgridIcon,
  sentry: sentryIcon,
  prometheus: prometheusIcon,
  render: renderIcon,
  dockerhub: dockerIcon,
  harness: harnessIcon,
  newrelic: newrelicIcon,
  servicenow: servicenowIcon,
  statuspage: statuspageIcon,
  launchdarkly: launchdarklyIcon,
  teams: teamsIcon,
  azure: azureIcon,
  graphql: graphqlIcon,
  aws: {
    cloudwatch: awsCloudwatchIcon,
    codeArtifact: awsCodeArtifactIcon,
    codepipeline: awsCodePipelineIcon,
    ecr: awsEcrIcon,
    lambda: awsLambdaIcon,
    sqs: awsSqsIcon,
    ec2: awsEc2Icon,
    route53: awsRoute53Icon,
    ecs: awsEcsIcon,
    sns: awsSnsIcon,
    prometheus: awsPrometheusIcon,
  },
  honeycomb: honeycombIcon,
  gcp: {
    cloudbuild: cloudBuildIcon,
    cloudfunctions: gcpCloudRunIcon,
    artifactregistry: gcpArtifactRegistryIcon,
    pubsub: gcpPubSubIcon,
    clouddns: gcpCloudDNSIcon,
    cloudsql: gcpCloudSqlIcon,
    storage: gcpStorageIcon,
    compute: gcpComputeIcon,
    createVM: gcpComputeIcon,
    deleteVMInstance: gcpComputeIcon,
    manageVMInstancePower: gcpComputeIcon,
    updateVMInstanceType: gcpComputeIcon,
    getVMInstanceMetrics: gcpComputeIcon,
    getVMInstance: gcpComputeIcon,
    createImage: gcpComputeIcon,
    updateImage: gcpComputeIcon,
    deleteImage: gcpComputeIcon,
    monitoring: gcpMonitoringIcon,
    prometheus: gcpMonitoringIcon,
  },
  elastic: elasticIcon,
  oci: ociIcon,
};

/**
 * Returns logo src for an integration type (e.g. "github" → github icon).
 * Use this for consistent integration icons in Settings tab and header.
 */
export function getIntegrationIconSrc(integrationName: string | undefined): string | undefined {
  if (!integrationName) return undefined;
  const key = integrationName.toLowerCase();
  return INTEGRATION_APP_LOGO_MAP[key];
}

/**
 * Returns logo src for the component header from block name (e.g. "github.runWorkflow" or "aws.lambda").
 * For AWS, uses the main AWS icon when no nested icon exists (e.g. aws.runFunction) instead of Lucide fallback.
 */
export function getHeaderIconSrc(blockName: string | undefined): string | undefined {
  if (!blockName) return undefined;
  const nameParts = blockName.split(".");
  const first = nameParts[0];
  if (!first) return undefined;
  const appLogo = APP_LOGO_MAP[first];
  if (typeof appLogo === "string") return appLogo;
  if (nameParts[1] && appLogo) {
    const nested = appLogo[nameParts[1]];
    if (nested) return nested;
  }
  // Use main AWS/GCP icon for components without a dedicated sub-icon mapping.
  if (first === "aws") return getIntegrationIconSrc("aws");
  if (first === "gcp") return getIntegrationIconSrc("gcp");
  return undefined;
}
